module.exports = __webpack_public_path__ + "img/psksntr6nj0jasr63l83rk97lq8m58h6zha77aa9a8b-4a18-480f-b59a-acab1e8ecfbd.2ed7b691.png";